import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import PeopleIcon from "@material-ui/icons/People";
import BarChartIcon from "@material-ui/icons/BarChart";
import LayersIcon from "@material-ui/icons/Layers";
import AssignmentIcon from "@material-ui/icons/Assignment";
import ApartmentIcon from "@material-ui/icons/Apartment";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import FormatPaintIcon from "@material-ui/icons/FormatPaint";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import LockIcon from "@material-ui/icons/Lock";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import MoneyIcon from "@material-ui/icons/Money";
import PaymentIcon from "@material-ui/icons/Payment";
import PersonPinCircleIcon from "@material-ui/icons/PersonPinCircle";

export function MainListItems() {
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"));
  const [role, setRole] = useState(
    JSON.parse(localStorage.getItem("currentUser"))?.role
  );
  // console.log(role, "role");
  const history = useHistory();
  const changeRoute = (path) => {
    history.push(path);
    if (path === "/login") window.location.reload();
  };
  const logout = (path) => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("currentUser");
    history.push(path);
    window.location.reload();
  };
  useEffect(() => {
    setAuthToken(localStorage.getItem("authToken"));
    setRole(JSON.parse(localStorage.getItem("currentUser"))?.role);
  }, [authToken, role]);
  return (
    <div>
      <ListItem
        button
        onClick={() => {
          changeRoute("/");
        }}
      >
        <ListItemIcon style={{ color: "#ccc" }}>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Home" />
      </ListItem>
      {/* <ListItem
        button
        onClick={() => {
          changeRoute("/example");
        }}
      >
        <ListItemIcon>
          <ShoppingCartIcon />
        </ListItemIcon>
        <ListItemText primary="Example" />
      </ListItem> */}

      {authToken && role === "admin" && (
        <ListItem
          button
          onClick={() => {
            changeRoute("/users");
          }}
        >
          <ListItemIcon style={{ color: "#ccc" }}>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary="Users" />
        </ListItem>
      )}

      {authToken && (role === "admin" || role === "moderator") && (
        <ListItem
          button
          onClick={() => {
            changeRoute("/farmers");
          }}
        >
          <ListItemIcon style={{ color: "#ccc" }}>
            <PersonPinCircleIcon />
          </ListItemIcon>
          <ListItemText primary="Farmers" />
        </ListItem>
      )}

      {/* <ListItem
        button
        onClick={() => {
          changeRoute("/sites");
        }}
      >
        <ListItemIcon>
          <ApartmentIcon />
        </ListItemIcon>
        <ListItemText primary="Sites" />
      </ListItem>

      <ListItem
        button
        onClick={() => {
          changeRoute("/daily-activities");
        }}
      >
        <ListItemIcon>
          <FormatPaintIcon />
        </ListItemIcon>
        <ListItemText primary="Daily Activities" />
      </ListItem>

      <ListItem
        button
        onClick={() => {
          changeRoute("/salary");
        }}
      >
        <ListItemIcon>
          <LocalAtmIcon />
        </ListItemIcon>
        <ListItemText primary="Employee Salary" />
      </ListItem>

      <ListItem
        button
        onClick={() => {
          changeRoute("/site-cost");
        }}
      >
        <ListItemIcon>
          <AttachMoneyIcon />
        </ListItemIcon>
        <ListItemText primary="Sites Cost" />
      </ListItem>

      <ListItem
        button
        onClick={() => {
          changeRoute("/cheque-deposit");
        }}
      >
        <ListItemIcon>
          <MoneyIcon />
        </ListItemIcon>
        <ListItemText primary="Cheques Deposit" />
      </ListItem>

      <ListItem
        button
        onClick={() => {
          changeRoute("/cheque-issue");
        }}
      >
        <ListItemIcon>
          <PaymentIcon />
        </ListItemIcon>
        <ListItemText primary="Cheques Issued" />
      </ListItem>

      <ListItem
        button
        onClick={() => {
          changeRoute("/daily-expense");
        }}
      >
        <ListItemIcon>
          <AccountBalanceIcon />
        </ListItemIcon>
        <ListItemText primary="Daily Cash Balance" />
      </ListItem> */}

      {/* <ListItem
        button
        onClick={() => {
          changeRoute("/add-employee");
        }}
      >
        <ListItemIcon>
          <BarChartIcon />
        </ListItemIcon>
        <ListItemText primary="Add Employee" />
      </ListItem> */}

      {authToken && (
        <ListItem
          button
          onClick={() => {
            logout("/login");
          }}
        >
          <ListItemIcon style={{ color: "#ccc" }}>
            <LockIcon />
          </ListItemIcon>
          <ListItemText primary="Log Out" />
        </ListItem>
      )}
      {!authToken && (
        <ListItem
          button
          onClick={() => {
            changeRoute("/login");
          }}
        >
          <ListItemIcon style={{ color: "#ccc" }}>
            <LockIcon />
          </ListItemIcon>
          <ListItemText primary="Log In" />
        </ListItem>
      )}
    </div>
  );
}

export const secondaryListItems = (
  <div>
    {/* <ListSubheader inset>Saved reports</ListSubheader>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Current month" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Last quarter" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Year-end sale" />
    </ListItem> */}
  </div>
);
